import { f as e } from "./fails.js";
var r = e(function () {
  if ("function" == typeof ArrayBuffer) {
    var e = new ArrayBuffer(8);
    Object.isExtensible(e) && Object.defineProperty(e, "a", {
      value: 8
    });
  }
});
export { r as a };